export default "__VITE_ASSET__67834c77__"